/**
 * User: ivanm
 * Date: 2/12/13
 * Registration Module used main code - used to start the module functions
 * used from the application
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var RegistrationRouteController = require("registration-controllers/RegistrationRouteController");

    LE.module('LERegistration', function (LERegistration, LE, Backbone) {

        LERegistration.addInitializer(function () {
            LERegistration.controller = new RegistrationRouteController();
        });

        LERegistration.on("start", function (options) {
            // do stuff after the module has been started
            if(LE.sessionManager && LE.sessionManager.isAuthenticated()) {
                LERegistration.controller.billingManager.addLpTagVar();
            }
        });

        LERegistration.getMainView = function () {
            return LERegistration.controller.getMainView();
        };

        LERegistration.getRouteController = function () {
            return LERegistration.controller;
        };

        LERegistration.lockReporting = true;
    });


    return LE.module("LERegistration");
});

